import { useHasPublishedChargeSchedules } from "./useHasPublishedChargeSchedules";

export const useCanSeeRecipeCodes = () => useHasPublishedChargeSchedules();
